import {FC} from 'react';

import {Box, useMediaQuery} from '@mui/material';
import {styled} from '@mui/material/styles';

import {Button} from 'components/button/Button';
import theme from 'config/theme';
import ReactNative from 'services/react-native';

import {zIndexes} from '../../constants/index';

export const StyledAddressDrawerFooterWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(0, 0, 2, 0),
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows[4],
  position: 'relative',
  zIndex: zIndexes.zIndexTen
}));

export const StyleFooterContentWrapper = styled(Box)<{isReactNativeView?: boolean}>(({theme, isReactNativeView}) => ({
  width: '-webkit-fill-available',
  padding: isReactNativeView ? theme.spacing(1, 2, 1, 2) : theme.spacing(2, 4, 0, 4),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& > div': {
    flex: 1
  }
}));

export const StyledBox = styled(Box)(({theme}) => ({
  background: theme.palette.common.mds_global_color_red_15
}));

export type AddressDrawerFooterProps = {
  actionButtonLabel: string;
  isDisabled: boolean;
  onClick?: () => void;
  loading?: boolean;
};

export const AddressDrawerFooter: FC<AddressDrawerFooterProps> = ({
  isDisabled,
  actionButtonLabel,
  onClick: handleClick,
  loading
}) => {
  const isReactNativeView = ReactNative.isReactNativeWebView();
  const isMobileView = useMediaQuery(theme.breakpoints.only('mobile'));

  return (
    <StyledAddressDrawerFooterWrapper>
      <StyleFooterContentWrapper isReactNativeView={isReactNativeView || isMobileView}>
        <Box>
          <Button
            fullWidth
            onClick={() => {
              handleClick?.();
            }}
            type="button"
            disabled={isDisabled || loading}
            color="primary"
            variant="contained"
            shape="rounded"
            loading={loading}
            id="btn_confirm"
          >
            {actionButtonLabel}
          </Button>
        </Box>
      </StyleFooterContentWrapper>
    </StyledAddressDrawerFooterWrapper>
  );
};

AddressDrawerFooter.displayName = 'AddressDrawerFooter';

export default AddressDrawerFooter;
